export default class Laberint {

	constructor(x, y, wlx, wly) {
		this.x = x;
		this.y = y;

		this.wlx = wlx;
		this.wly = wly;

		this.arrh = [];
		this.arrv = [];

		this.endCells = new Set();
		this.endCellsArr = [];

		this.setup();
	}

	setup() {
		this.initEmptyArrays();
		this.initExternalDoors();
		this.rng = new Math.seedrandom(this.x * 1000 + this.y * 1000)
		this.randomlyCreateWalls();
	}

	initEmptyArrays() {
		// Línies horitzontals
		for (let i = 0; i < this.wlx; i++) {
			this.arrh[i] = [];
			for (let j = 0; j <= this.wly; j++) {
				this.arrh[i][j] = 0;
			}
		}

		// Línies verticals
		for (let i = 0; i <= this.wlx; i++) {
			this.arrv[i] = [];
			for (let j = 0; j < this.wly; j++) {
				this.arrv[i][j] = 0;
			}
		}

		// Cel·les de sortida
		for (let i = 0; i < this.wlx; i++) {
			this.endCellsArr[i] = [];
			for (let j = 0; j < this.wly; j++) {
				this.endCellsArr[i][j] = false;
			}
		}
	}

	randomSeed(position) {
		switch(position) {
			case 'left':
				return this.x * 1000 + this.y * 10000;
			case 'right':
				return (this.x + 1) * 1000 + this.y * 10000;
			case 'top':
				return this.x * 10000 + this.y * 1000;
			case 'bottom':
				return this.x * 10000 + (this.y + 1)  * 1000;
		}
	}

	random(max, seed) {
		const rng = new Math.seedrandom(seed)
		return Math.round(rng() * max)
	}

	initExternalDoors() {

		// Línies verticals
		const openposLeft = this.random(this.wly - 1, this.randomSeed('left'));
		this.endCells.add(this.getCellId(0, openposLeft));
		this.endCellsArr[0][openposLeft] = true;
		const openposRight = this.random(this.wly - 1, this.randomSeed('right'));
		this.endCells.add(this.getCellId(this.wlx - 1, openposRight));
		this.endCellsArr[this.wlx - 1][openposRight] = true;
		for (let j = 0; j < this.wly; j++) {
			this.arrv[0][j] = (j === openposLeft ? 0 : 1);
			this.arrv[this.wlx][j] = (j === openposRight ? 0 : 1);
		}

		// Línies horitzontals
		let openposTop = this.random(this.wlx - 1, this.randomSeed('top'));
		this.endCells.add(this.getCellId(openposTop, 0));
		this.endCellsArr[openposTop][0] = true;
		let openposBottom = this.random(this.wlx - 1, this.randomSeed('bottom'));
		this.endCells.add(this.getCellId(openposBottom, (this.wly - 1)));
		this.endCellsArr[openposBottom][this.wly - 1] = true;
		for (let i = 0; i < this.wlx; i++) {
			this.arrh[i][0] = (i === openposTop ? 0 : 1);
			this.arrh[i][this.wly] = (i === openposBottom ? 0 : 1);
		}

	}

	possibleInteriorWalls() {
		let walls = [];

		// Línies horitzontals
		for (let i = 0; i < this.wlx; i++) {
			for (let j = 1; j < this.wly; j++) {
				walls.push({
					"i": i,
					"j": j,
					"dir": "x"
				});
			}
		}

		// Línies verticals
		for (let i = 1; i < this.wlx; i++) {
			for (let j = 0; j < this.wly; j++) {
				walls.push({
					"i": i,
					"j": j,
					"dir": "y"
				});
			}
		}

		return walls;
	}

	shuffleArray(array) {
		for (let i = array.length - 1; i > 0; i--) {
			const j = Math.floor(this.rng() * (i + 1));
			[array[i], array[j]] = [array[j], array[i]];
		}
	}

	setWall(wall, value) {
		if (wall.dir === "x") {
			this.arrh[wall.i][wall.j] = value;
		} else {
			this.arrv[wall.i][wall.j] = value;
		}
	}

	canGoLeft(i, j) {
		return (i > 0) && (this.arrv[i][j] === 0);
	}

	canGoRight(i, j) {
		return (i < this.wlx - 1) && (this.arrv[i + 1][j] === 0);
	}

	canGoUp(i, j) {
		return (j > 0) && (this.arrh[i][j] === 0);
	}

	canGoDown(i, j) {
		return (j < this.wly - 1) && (this.arrh[i][j + 1] === 0);
	}

	getCellId(i, j) {
		return "i" + i + "j" + j;
	}

	checkAllAccessibleCells(i, j, visited) {
		visited.add(this.getCellId(i, j));

		let len = 1;
		if (this.canGoUp(i, j) && !visited.has(this.getCellId(i, j - 1))) {
			const lenUp = this.checkAllAccessibleCells(i, j - 1, visited);
			len = Math.max(len, 1 + lenUp);
		}

		if (this.canGoDown(i, j) && !visited.has(this.getCellId(i, j + 1))) {
			const lenDown = this.checkAllAccessibleCells(i, j + 1, visited);
			len = Math.max(len, 1 + lenDown);
		}

		if (this.canGoLeft(i, j) && !visited.has(this.getCellId(i - 1, j))) {
			const lenLeft = this.checkAllAccessibleCells(i - 1, j, visited);
			len = Math.max(len, 1 + lenLeft);
		}

		if (this.canGoRight(i, j) && !visited.has(this.getCellId(i + 1, j))) {
			const lenRight = this.checkAllAccessibleCells(i + 1, j, visited);
			len = Math.max(len, 1 + lenRight);
		}

		return len;
	}

	randomlyCreateWalls() {
		const walls = this.possibleInteriorWalls();
		this.shuffleArray(walls);

		const wallsSet = new Set();
		for (let i = 0; i < walls.length; i++) {
			wallsSet.add(walls[i]);
		}

		const numPossibilitats = 4;


		while (wallsSet.size > 0) {
			let longestWall = null;
			let longestLen = -1;

			// Triem el que crea el camí més llarg entre numPossibilitats
			const wallIt = wallsSet.values();
			for (let i = 0; i < Math.min(numPossibilitats, wallsSet.size); i++) {
				const wall = wallIt.next().value;

				const len = this.checkNewWallMinLength(wall);
				if (len < 0) {
					// Si el mur el fa no connectabe l'eliminem
					wallsSet.delete(wall);
				} else if (len > longestLen) {
					longestLen = len;
					longestWall = wall;
				}
			}

			if (longestWall != null) {
				this.setWall(longestWall, 1);
				wallsSet.delete(longestWall);
			}
		}
	}

	checkNewWallMinLength(wall) {
		this.setWall(wall, 1);
		const accessibleCells = new Set();
		const len = this.checkAllAccessibleCells(0, 0, accessibleCells);
		this.setWall(wall, 0);

		if (accessibleCells.size < this.wlx * this.wly) {
			return -1;
		} else {
			return len;
		}
	}

}
